import { useEffect, useRef, useState } from "preact/hooks";
import type { App } from "../app.ts";

export type NewMode = "thought" | "document" | null;

export function NewForm({
  app,
  mode,
  done,
}: {
  app: App;
  mode: "thought" | "document";
  done: () => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  const [error, setError] = useState("");
  useEffect(() => input.current?.focus(), []);

  const submit = async (e: Event) => {
    e.preventDefault();
    const value = input.current?.value ?? "";
    const res =
      mode === "thought" ? await app.createThought(value) : await app.createDocument(value);
    if (res.ok) {
      done();
      app.toggleSidebar(false);
    } else {
      setError(res.message ?? "");
    }
  };

  return (
    <form class="new-form" onSubmit={submit}>
      <label for="new-name" class="label">
        {mode === "thought" ? "Title" : "File name"}
      </label>
      <input
        id="new-name"
        ref={input}
        class="field"
        type="text"
        autocomplete="off"
        placeholder={mode === "thought" ? "[Title of the thought]" : "[file-name]"}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.stopPropagation();
            done();
          }
        }}
      />
      <p class="form-error" role="alert">
        {error}
      </p>
      <div class="row">
        <button class="button primary" type="submit">
          Create
        </button>
        <button class="button" type="button" onClick={done}>
          Cancel
        </button>
      </div>
    </form>
  );
}
